import { UI, HStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { IBlockedAssetNormalized } from '../../../../../../store/customerDetail/types';
import { LoadingTable } from '../../../shared/LoadingTable';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';

import { desktopMaxHeight, desktopWidthCols, emptyListProps, tableHead } from './constants';

import { BlockedTypes } from '.';

export const ItemDesktopWrapper: React.FC = () => (
  <Box w="full" h="1px" bgColor="neutral.lightest" />
);

interface ProductItemProps {
  item: IBlockedAssetNormalized;
}

export const ItemDesktop: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <HStack my="stack.xxxs">
      <UI.TableItem testId={'table-description'} width={desktopWidthCols.description}>
        <UI.Text>{item.description}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-value'} width={desktopWidthCols.value} align="end">
        <UI.Text>{Utils.Mask.Money(item.value)}</UI.Text>
      </UI.TableItem>
    </HStack>
  );
};

export const BlockedDesktop: React.FC<BlockedTypes.Props> = ({
  isLoading,
  blockedAssets,
  error,
  onRefresh,
}) => {
  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={onRefresh} />;
    }
    if (blockedAssets.length === 0 && !isLoading) {
      return <EmptyList {...emptyListProps} />;
    }
    return (
      <UI.Table testId="table-blocked" isLoading={false} cols={3} rows={5}>
        <UI.TableHead testId="table-blocked-head">
          {Object.entries(tableHead).map((tableHeadItem, index) => {
            const width = Object.entries(desktopWidthCols).map((col) => col[1])[index];

            return (
              <UI.TableTitle
                key={tableHeadItem[0]}
                testId={`table-blocked-title-${index}`}
                width={width}
                textAlign={tableHeadItem[0] === 'value' ? 'end' : 'initial'}
                hasPaddingRight={tableHeadItem[0] === 'value'}>
                {tableHeadItem[1] as string}
              </UI.TableTitle>
            );
          })}
        </UI.TableHead>

        {isLoading ? (
          <LoadingTable columnsWidths={desktopWidthCols} />
        ) : (
          <FlatList
            windowSize={20}
            maxToRenderPerBatch={20}
            updateCellsBatchingPeriod={5}
            data={blockedAssets}
            ItemSeparatorComponent={ItemDesktopWrapper}
            contentContainerStyle={{ maxHeight: desktopMaxHeight }}
            showsVerticalScrollIndicator={false}
            onEndReachedThreshold={1.5}
            renderItem={({ item }) => <ItemDesktop item={item} />}
          />
        )}
      </UI.Table>
    );
  };

  return (
    <UI.Shadow
      level={1}
      borderRadius="sm"
      my="inset.sm"
      paddingX="inline.xxxs"
      paddingY="inline.xxs"
      pb={0}>
      {renderTable()}
    </UI.Shadow>
  );
};
